import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { Input } from 'components/global/atoms'
import DatePickerComponent from 'components/global/DatePicker'
import { CSSProperties, memo } from 'react'
import { FieldValidator } from 'final-form'
import { ReactDatePickerProps } from 'react-datepicker'

type DatePickerType = Omit<ReactDatePickerProps, 'onChange'> & {
  disabledTooltip?: string
  label?: string
  name: string
  placeholder?: string
  positionFixed?: boolean
  status?: string
  statusMessage?: string
  testId?: string
  validate?: FieldValidator<any>
  onChange?: (e: string) => void
  style?: CSSProperties
  displayFormat?: string
  customEndIcon?: JSX.Element
}

export const DatePickerDSField = ({
  disabled,
  name,
  onChange,
  validate,
  popperPlacement,
  status,
  statusMessage,
  testId,
  ...rest
}: DatePickerType): JSX.Element => (
  <Field
    name={name}
    validate={validate}
  >
    {({ input, meta }): JSX.Element => (
      <DatePickerComponent
        events={[]}
        {...rest}
        {...input}
        data-testid={testId}
        status={(meta.error && meta.touched && 'error') || status}
        statusMessage={meta.error || statusMessage}
        selected={input.value && new Date(input.value)}
        popperPlacement={popperPlacement || 'auto'}
        onChange={(val: string): void => {
          input.onChange(val)
          if (onChange) {
            onChange(val)
          }
        }}
        disabled={disabled}
      />
    )}
  </Field>
)

DatePickerDSField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  status: PropTypes.string,
  statusMessage: PropTypes.string,
  size: PropTypes.string,
  popperPlacement: PropTypes.string,
  onChange: PropTypes.func,
  validate: PropTypes.func,
  testId: PropTypes.string,
}

DatePickerDSField.defaultProps = {
  size: 'large',
}

const DatePickerField = ({
  disabled,
  name,
  onChange,
  validate,
  ...rest
}: DatePickerType): JSX.Element => (
  <Field
    name={name}
    validate={validate}
  >
    {({ input }): JSX.Element => (
      <Input.DatePicker
        {...rest}
        {...input}
        onChange={(val: string): void => {
          input.onChange(val)
          if (onChange) {
            onChange(val)
          }
        }}
        isDisabled={disabled}
      />
    )}
  </Field>
)

DatePickerField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  validate: PropTypes.func,
}

export default memo(DatePickerField)
